import { startQuasarApp } from '@ligo/shared/quasar';
import { bootFiles } from './boot';
import store from './store';
import router from './router';
import App from './App.vue';

import './css/quasar.sass';

startQuasarApp(App, bootFiles, { store, router });
